import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTokenFromLink } from '../../hooks/useTokenFromLink';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const inputStyle = {
  width: '100%',
  height: 48,
  padding: '0 14px',
  borderRadius: 10,
  border: '1px solid #e5e7eb',
  fontSize: 14,
  outline: 'none',
  boxSizing: 'border-box',
};

export default function MarketResetPassword() {
  const navigate = useNavigate();
  // 🔑 hooks/useTokenFromLink: read once, stripped from the address bar, no-referrer while the page is open.
  const token = useTokenFromLink();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setError('Missing reset token. Please use the link from your email.');
      return;
    }
    if (pw.length < 8 || !/\d/.test(pw) || !/[A-Z]/.test(pw)) {
      setError('Password must be at least 8 characters and include a number and an uppercase letter.');
      return;
    }
    if (pw !== pw2) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/market/auth/reset-password`, { token, password: pw });
      setDone(true);
      setTimeout(() => navigate('/market/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. Please request a new link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Link to="/market" style={{ textDecoration: 'none', display: 'inline-block' }}>
            <img
              src="/doorly-market-logo.png"
              alt="Doorly Market"
              style={{ height: '36px', width: 'auto', display: 'block', margin: '0 auto' }}
            />
          </Link>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '16px 0 4px' }}>Reset Password</h1>
          <p style={{ color: '#6b7280', fontSize: 13 }}>Choose a new password for your account.</p>
        </div>

        <div style={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: 16, padding: 28 }}>
          {done ? (
            <div style={{ textAlign: 'center', color: '#374151', fontSize: 14 }}>
              Password updated. Redirecting to sign in…
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              {error && (
                <div style={{ marginBottom: 14, padding: '10px 14px', borderRadius: 10, backgroundColor: '#fff5f6', border: '1px solid #ffd6db', color: '#ff082f', fontSize: 13 }}>
                  {error}
                </div>
              )}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>New password</label>
                <input
                  type="password"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  style={inputStyle}
                />
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>8+ chars, 1 number, 1 uppercase</div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Confirm password</label>
                <input
                  type="password"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  style={inputStyle}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  height: 48,
                  borderRadius: 100,
                  border: 'none',
                  backgroundColor: '#3a6ad9',
                  color: '#fff',
                  fontWeight: 700,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? 'Saving...' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
